var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('div',{attrs:{"id":"bi-main"},domProps:{"innerHTML":_vm._s(_vm.view.embendedCode)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }